













































import { Component } from 'vue-property-decorator'
import LangSwitcher from '@/components/common/LangSwitcher.vue'
import ThemeSwitcher from '@/components/common/ThemeSwitcher.vue'
import Messages from '@/components/common/Messages.vue'
import { logout } from '@/request/apis/UserRequest'
import RouterHelper from '@/mixins/RouterHelper.vue'
import { mapState } from 'vuex'
import { getMessageList } from '@/request/apis/Message'
import { RawLocation } from 'vue-router'

@Component({
  computed: {
    ...mapState(['userInfo'])
  },
  components: { ThemeSwitcher, LangSwitcher, Messages }
})
export default class HeaderBar extends RouterHelper {
  private wsUrl: string = `/`

  // 是否切换到任务管理页
  private get isTaskPath () {
    return this.$route.path.includes('/TaskManagement')
  }

  /**
   * logout
   */
  protected async logoutHandler (): Promise<void> {
    try {
      const logoutRequest = logout(document.body)
      await logoutRequest.start()
      // @ts-ignore
      await this.$router.push(this.getCompleteRouteByPathString('login'))
    } catch (e) {
      console.error(e)
    }
  }

  /**
   * 获取消息列表
   * @private
   */
  // private getMessageList () {
  //   return getMessageList(null).start()
  // }
}
